import { ppFetch, type PpFetchSettings } from './pp-fetch';
import { getJwt } from './jwt-client';
import { computeDeviceFingerprint } from './device-fingerprint';

/**
 * Bearer-aware wrapper around ppFetch.
 * Obtains a JWT from jwt-client and adds an Authorization: Bearer header
 * before forwarding to ppFetch. If getJwt() returns null (unauthenticated),
 * the request is sent without the header — the caller may receive 401.
 * Also attaches x-pp-device-fp for abuse-analytics capture (spec D5).
 */
export async function apiFetch<T = unknown>(settings: PpFetchSettings): Promise<T> {
  const [jwt, fp] = await Promise.all([
    getJwt(),
    computeDeviceFingerprint().catch(() => ''),
  ]);
  const headers: Record<string, string> = { ...(settings.headers ?? {}) };
  if (jwt !== null) {
    headers['Authorization'] = `Bearer ${jwt}`;
  }
  if (fp) {
    // omit header when fingerprinting unavailable (privacy-mode / non-secure context)
    headers['x-pp-device-fp'] = fp;
  }
  return ppFetch<T>({ ...settings, headers });
}
